<template>
    <div
        class="px-5 py-0 space-y-3"
        role="radiogroup"
        aria-label="Target value"
    >
        <button
            v-for="value in values"
            :key="value.ulid"
            type="button"
            :disabled="readOnly"
            @click="handleClick(value)"
            :class="isSelected(value) ? selected : unselected"
            role="radio"
            :aria-checked="isSelected(value)"
            :title="value.display"
            class="flex min-w-0 max-w-full space-x-1 bg-transparent p-0 border-0 text-left"
        >
            <div class="shrink-0">
                <zen-icon-box-checked
                    v-if="isSelected(value)"
                    aria-hidden="true"
                />
                <zen-icon-box-empty
                    v-if="!isSelected(value)"
                    aria-hidden="true"
                />
            </div>
            <div class="min-w-0">
                <span v-if="isEmpty(value)" class="italic"> (empty) </span>
                <span v-else class="font-mono text-sm break-all">
                    {{ label(value) }}
                </span>
            </div>
        </button>
    </div>
</template>

<script>
import { truncateDisplay } from '@/utils/formatters'

// Value picker for json-typed flags. Mirrors NumberTargetToggle (one radio
// per flag value, keyed on ulid) but renders each value's canonical JSON in
// monospace, truncated so a large document can't blow out the layout; the
// full value is available on hover via the title attribute.
export default {
    name: 'JsonTargetToggle',
    computed: {
        selected() {
            return (
                'text-taupe-800' + (this.readOnly ? ' cursor-not-allowed' : '')
            )
        },
        unselected() {
            return (
                'text-taupe-500 ' +
                (this.readOnly
                    ? 'cursor-not-allowed'
                    : 'hover:text-sky-500 cursor-pointer')
            )
        },
    },
    methods: {
        isEmpty(value) {
            return (
                value.display === '' ||
                value.display === null ||
                value.display === undefined
            )
        },
        label(value) {
            return truncateDisplay(value.display)
        },
        isSelected(value) {
            return (
                this.currentValue != null &&
                this.currentValue.ulid == value.ulid
            )
        },
        handleClick(value) {
            if (!this.isSelected(value)) {
                this.toggle(value)
            }
        },
        toggle(value) {
            if (this.readOnly) {
                return
            }

            this.$emit('toggle', value)
        },
    },
    emits: ['toggle'],
    props: {
        readOnly: {
            type: Boolean,
            required: false,
            default: false,
        },
        currentValue: {
            type: Object,
            required: false,
            default: null,
        },
        values: {
            type: Array,
            required: false,
            default: () => [],
        },
    },
}
</script>
